import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import StockForm from '../Form';
import { createStock } from '@resources/Stock/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createStock, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createStock(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.stock.create',
						defaultMessage:
							'A new Stock has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.stock',
					defaultMessage: 'Create Stock',
				})}
			</Title>
			<StockForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	stocks,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		stocks,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createStock,
	fetchModulesBySubmoduleCode,
})(Create);
